// extracted by mini-css-extract-plugin
export default {"Header":"tU3-p","HeaderPartner":"wIi-L","divider":"PiR8w","header":"pmyGI","logo":"IOyOb","skeleton-progress":"bP-Kv"};